import React from 'react';
import PropTypes from 'prop-types';
import css from './WhereWorksBest.module.css';

const WhereWorksBest = ({ content }) => {
  return (
    <section className={css.panel} aria-labelledby="where-works-best-heading">
      <h2 id="where-works-best-heading" className={css.heading}>
        Where This Item Works Best
      </h2>
      <div
        className={css.content}
        dangerouslySetInnerHTML={{ __html: content }}
      />
    </section>
  );
};

WhereWorksBest.propTypes = {
  content: PropTypes.string.isRequired,
};

export default WhereWorksBest;
